import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import Carousel from 'react-multi-carousel';

import { set_go_to_page, set_is_loading } from "../../../../../actions";

import { sliderConfigs, singleSliderConfigs } from '../../../../../Constants/user';

import 'react-multi-carousel/lib/styles.css';
import './style.scss';

class ProjectCard extends PureComponent {
    constructor(props) {
        super(props);

        this.profile = props.profile.find(({ portfolioId }) => portfolioId === props.selectedProject);
        this.images = this.profile.images.map(({ src }) => src);

        const language = this.profile.data.find(({ language }) => language === props.lang);

        this.state = {
            language,
            isOpened: false,
            device: this.getDeviceType(),
        };
    }

    componentDidUpdate(prevProps) {
        const { width, lang } = this.props;
        if (prevProps.lang !== lang) {
            const language = this.profile.data.find(({ language }) => language === lang);

            this.setState({
                language,
            })
        }
        if (prevProps.width !== width) {
            this.setState({
                device: this.getDeviceType(),
            })
        }
    }

    componentWillUnmount() {
        if (!this.goBackPressed) {
            this.props.goToPage(0);
        }
    }

    getDeviceType = () => {
        const { width } = this.props;
        return width > 1024 ? 'desktop' : (width < 1024 && width > 400) ? 'tablet' : 'mobile';
    };

    goBack = () => {
        this.goBackPressed = true;
        this.props.goToPage(2);
    };

    openZoom = i => {
        let images = this.images.slice(i);
        images.push(...this.images.slice(0, i));

        this.setState({
            images,
            isOpened: true,
        })
    };

    render() {
        const { language: { title, text }, device, isOpened, images } = this.state;
        const { componentRef: { current: element } } = this.props;

        return (
            <div className="projectCard">
                <div className="textContainer">
                    <div className="nameRow">{title}</div>
                    <div className="yearBack">
                        {!this.profile.year ? <div/> : <div className="year">{this.profile.year}</div>}
                        <img src="/images/userPage/Icons/Rectangle.png" alt="" onClick={this.goBack}/>
                    </div>
                    <div className="text">
                        {text.split('\n').map((row, index) => (
                            <div key={index}>{row}</div>
                        ))}
                    </div>
                </div>
                <div className="imageSlider">
                    <Carousel
                        infinite
                        swipeable
                        focusOnSelect
                        draggable={false}
                        autoPlaySpeed={4000}
                        transitionDuration={1000}
                        responsive={sliderConfigs}
                        autoPlay={device === 'mobile'}
                        containerClass="carouselContainer"
                        removeArrowOnDeviceType={["tablet", "mobile"]}
                    >
                        {this.images.map((src, i) => (
                            <div className="imageContainer">
                                <img
                                    alt
                                    src={'/images/portfolios/' + src}
                                    onClick={() => this.openZoom(i)}
                                />
                            </div>
                        ))}
                    </Carousel>
                </div>
                {isOpened && (
                    <div
                        id="imageSliderOverlay"
                        onClick={() => {
                            this.setState({
                                isOpened: false,
                            })
                        }}
                    >
                        <div
                            onClick={e => e.stopPropagation()}
                            id="overlaySlider"
                            ref={this.overLay}
                        >
                            <Carousel
                                infinite
                                swipeable={true}
                                deviceType={device}
                                transitionDuration={1000}
                                containerClass="imageCarousel"
                                responsive={singleSliderConfigs}
                            >
                                {images.map(src => (
                                    <div style={{
                                        background: `url(/images/portfolios/${src})`,
                                        backgroundSize: 'contain',
                                        width: '90vw',
                                        height: '90vh',
                                        backgroundRepeat: 'no-repeat',
                                        backgroundPosition: 'center center',
                                    }}/>
                                ))}
                            </Carousel>
                        </div>
                    </div>
                )}
            </div>
        );
    }
}

const mapStateToProps = ({ portfolio: { profile, selectedProject }, main: { lang, width, height } }) => ({
    lang,
    width,
    height,
    profile,
    selectedProject,
});

const mapDispatchToProps = dispatch => ({
    goToPage: page => dispatch(set_go_to_page(page)),
    setLoading: state => dispatch(set_is_loading(state)),
});

export default connect(mapStateToProps, mapDispatchToProps)(ProjectCard);
